import Image from 'next/image';
import Link from 'next/link';
export function ReferalInfoCard() {
  return <div className="relative  flex w-full items-start  text-white text-opacity-80" data-sentry-component="ReferalInfoCard" data-sentry-source-file="referal-info-card.tsx">
      <div className="flex flex-1 shrink basis-0 flex-col overflow-hidden p-3 pb-0 md:min-w-[240px]">
        <p className="mb-2 text-xl font-semibold tracking-tight text-white">
          Refer and earn upto
          {' '}
          <br />
          ₹ 1,00,000 and more!
        </p>
        <div className="mt-1 text-xs font-medium tracking-normal md:text-sm">
          <p>
            Earn 20% per referral purchase by sharing your link below to your friends.
          </p>
        </div>
        <p className="mt-5 text-xs">
          *Applicable for regular courses only.
        </p>
        <p className="absolute bottom-0 right-0 flex items-center justify-center gap-1 text-xs">
          <Link href="/terms-and-conditions" type="button" className="text-xs underline" data-sentry-element="Link" data-sentry-source-file="referal-info-card.tsx">T&C</Link>
          apply
        </p>
      </div>
      <Image height={100} width={100} loading="lazy" src="/Single-Gold-coin.svg" alt="" className="aspect-square w-[65px] shrink-0 rounded-md object-contain" data-sentry-element="Image" data-sentry-source-file="referal-info-card.tsx" />
    </div>;
}